module.exports = __webpack_public_path__ + "media/images/emblems/Balerna-coat_of_arms-cc9b0bdda17c4dd75cb758911c85e63a.svg";